import { render, staticRenderFns } from "./MembershipIntegrations.vue?vue&type=template&id=23b5c64d&"
import script from "./MembershipIntegrations.vue?vue&type=script&lang=js&"
export * from "./MembershipIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports